<template>
    <div class="bottomPage">
        <div class="e-flex bottomPageFlex">
          <div class="flexAll">
            <img class="bottomLogo" src="@/assets/images/bottomLogo.png">
            <div class="bottomInfo">
              <div class="bottomInfoList">服务热线：010-69751170</div>
              <div class="bottomInfoList">电子邮箱：kechuangfuwu@wlkjc.com</div>
              <div class="bottomInfoList">联系地址：北京市昌平区未来科学城未来视界C座9层</div>
              <div class="bottomInfoList bottomInfoListTop">工作入口：<span style="cursor: pointer;" @click="openPage('https://manage.kechuangfuwu.com/')">管理后台</span></div>
              <div class="bottomInfoList">友情链接：<span style="cursor: pointer;" @click="openPage('http://www.wlkxcgs.com/')">北京未来科学城发展集团</span>&nbsp;&nbsp;<span style="cursor: pointer;" @click="openPage('https://www.bjchp.gov.cn/')">北京市昌平区人民政府</span>&nbsp;&nbsp;<span style="cursor: pointer;" @click="openPage('https://www.beijing.gov.cn/')">北京市人民政府</span>&nbsp;&nbsp;<span style="cursor: pointer;" @click="openPage('https://open.beijing.gov.cn/front/getListIndex2021.do?nid=18')">开放北京</span></div>
            </div>
          </div>
          <div style="display: flex;">
            <div class="bottomRight" style="margin-right:0.4166666666666667rem;">
              <img class="bottomQrImg" src="@/assets/images/bottomQrImg.jpg" style="margin: 0 auto;">
              <div class="bottomRightText">“两区”服务平台微信公众号</div>
            </div>
            <div class="bottomRight">
              <img class="bottomQrImg" src="@/assets/images/bottomQrImg1.jpg" style="margin: 0 auto;">
              <div class="bottomRightText">开放北京微信公众号</div>
            </div>
          </div>
        </div>
        <div class="beianContent">
          <div class="beianList">Copyright© 2017-2019 北京未来科学城产业发展有限公司 版权所有</div>
          <div class="beianList">北京市昌平区北七家镇未来科学城东路一号院A106室 <span style="cursor: pointer;" @click="openPage('https://beian.miit.gov.cn/#/Integrated/index')">京ICP备17060083号-2</span></div>
        </div>
      </div>
  </template>
  
  <script>
    export default {
        name: 'bottom',
        data () {
            return {
                
            }
        },
        methods: {
          openPage(url) {
            window.open(url)
          }
        }
    }
  </script>
  

  <style scoped>
    
  </style>
  


// WEBPACK FOOTER //
// src/components/bottom.vue